<template>
  <div class="alert alert-danger">
    {{alertMessage}}
  </div>
</template>

<script>
export default {
  props: ['alertMessage']
}
</script>



// WEBPACK FOOTER //
// alert.vue?14cd04eb